module.exports = "@import url(\"https://cdn.jsdelivr.net/npm/gijgo@1.9.6/css/gijgo.min.css\");"